import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { User as UserType, UserListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const USER_FIELDS = `aliases allowedLocationIds archived assignedLocationIds assignedWorkspaceIds createdDate email id jobTitle lastLoginDate name orgId phone position preferredChannel role roleId timezone type updatedDate version workspaceId workspaces { id locationIds roleId }`

const LIST_QUERY = graphql(`
  query Users($search: String, $pagination: PaginationInput, $sort: SortInput) {
    users(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        aliases
        allowedLocationIds
        archived
        assignedLocationIds
        assignedWorkspaceIds
        createdDate
        email
        id
        jobTitle
        lastLoginDate
        name
        orgId
        phone
        position
        preferredChannel
        role
        roleId
        timezone
        type
        updatedDate
        version
        workspaceId
        workspaces {
          id
          locationIds
          roleId
        }
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query User($id: ID!) {
    user(id: $id) {
      aliases
      allowedLocationIds
      archived
      assignedLocationIds
      assignedWorkspaceIds
      createdDate
      email
      id
      jobTitle
      lastLoginDate
      name
      orgId
      phone
      position
      preferredChannel
      role
      roleId
      timezone
      type
      updatedDate
      version
      workspaceId
      workspaces {
        id
        locationIds
        roleId
      }
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      aliases
      allowedLocationIds
      archived
      assignedLocationIds
      assignedWorkspaceIds
      createdDate
      email
      id
      jobTitle
      lastLoginDate
      name
      orgId
      phone
      position
      preferredChannel
      role
      roleId
      timezone
      type
      updatedDate
      version
      workspaceId
      workspaces {
        id
        locationIds
        roleId
      }
    }
  }
`)

export class UserStore extends EntityStore<UserType, UserListResult, undefined, typeof UPDATE_MUTATION> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `User`,
      extractList: (data: any) => data.users,
      extractOne: (data: any) => data.user,
      extractMutated: (data: any) => data.updateUser,
    })
  }
}
